import { useEffect, FC } from "react";
import "./style.scss";
import { uuidRegex } from "../../Utils/common";

type AppointmentProps = {
    appointmentId: string
}

const Appointment: FC<AppointmentProps> = ({ appointmentId }) => {

    useEffect(() => {
        const script = document.createElement("script");

        script.src = "https://cal.waymore.io/appointment.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [appointmentId]);

    return (
        <div className="appointmentContainer">
            {uuidRegex.test(appointmentId) ? < div className="content-container">
                <div className="appointment-div">
                    <div className="elementor-widget-container">
                        <div
                            className="ea-widget"
                            data-url={`https://cal.waymore.io/index.php/booking/${appointmentId}`}
                        ></div>
                    </div>
                </div>
            </div> : appointmentId.length === 36 ? <div>Appointment id is not valid</div> : <div>Appointment preview will be shown here</div>
            }
        </div >
    );
}

export default Appointment;
